<div class="notification-center">
  <h2 class="main-headline container">Notification Center</h2>

  <div class="placeholder container" *ngIf="(!showStatus || !statusApi) && !incidents?.length && !news.length">
    <i class="far fa-comment-alt-slash"></i>
    <h3>{{ 'notification_center_placeholder' | uitranslate }}</h3>
  </div>

  <div *ngIf="statusApi && showStatus" class="platform-status container" [ngClass]="{ 'has-border': incidents.length || news.length }">
    <div class="two spaced cells">
      <span class="platform-status__headline">{{ 'platformstatus' | uitranslate }}</span>
      <a class="right aligned external link status-link" [attr.href]="statusPage" target="_blank" *ngIf="statusPage">
        <i class="icon-a106_linkextern"></i>
        <span>{{ 'statuspage' | uitranslate }}</span>
      </a>
    </div>
    <div class="status-text" *ngIf="overalStatus" [ngClass]="{ issues: overalStatus.issues, offline: !overalStatus.online, online: overalStatus.online }">
      {{ overalStatus.text }}
    </div>
    <div class="status-text offline" *ngIf="!overalStatus">{{ 'status_pending' | uitranslate }} ...</div>
  </div>

  <div class="incidents container" *ngIf="incidents.length" [ngClass]="{ 'has-border': news.length }">
    <h3>{{ 'maintenance_incidents' | uitranslate }}</h3>
    <div class="incident" *ngFor="let incident of incidents">
      <div class="scheduled-container">
        <div class="time-container">
          <span class="scheduled">{{ incident.scheduled_at }}</span>
          <span class="time-left" *ngIf="incident.scheduled_today">{{ incident.time_left }}</span>
        </div>
        <span class="status-badge" [ngClass]="incident.statusClass" *ngIf="incident.statusClass">{{ 'incident_' + incident.statusClass | uitranslate }}</span>
      </div>
      <h4>
        <i class="p-mr-1 fal fa-wrench" *ngIf="incident.status === 0"></i>
        <i class="p-mr-1 fal fa-exclamation-triangle" *ngIf="incident.status !== 0"></i>
        {{ incident.name }}
      </h4>
      <p [innerHTML]="incident.message"></p>
    </div>
  </div>

  <ng-content></ng-content>

  <div class="news container" *ngIf="news.length">
    <div class="news-header">
      <h3>{{ 'notification_center_release_notes_label' | uitranslate }}</h3>
      <a href="https://gridscale.io/feed/releasenotes" target="_blank"><i class="fa fa-rss"></i> {{ 'notification_center_release_notes_subscribe' | uitranslate }}</a>
    </div>
    <ig-news-entry [news]="news"></ig-news-entry>

    <br />

    <a class="link all-release-notes" target="_blank" [attr.href]="releaseNotesUrl">
      <i class="fal fa-external-link"></i>
      <span>{{ 'release_notes_all' | uitranslate }}</span>
    </a>
  </div>
</div>
